// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ArCzp","checkboxCol":"Table_checkboxCol__1nU7E","emailCol":"Table_emailCol__2EH-I","actionCol":"Table_actionCol__16Hlu"};